export default __webpack_public_path__ + "static/media/er.b9c22599.png";